import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { OrderService } from '@app/services/order.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-assign-order-modal',
  templateUrl: './assign-order-modal.component.html',
  styleUrls: ['./assign-order-modal.component.scss']
})
export class AssignOrderModalComponent implements OnInit, OnChanges {

  @Input() orderIds: string[] = []; // Pass order IDs from parent
  @Input() visible: boolean = false; // Show/hide modal
  @Input() isassign: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() assign = new EventEmitter<{ driver: string, orders: string[] }>();

  selectedDriver: string = '';

  orderCount: number = 0;
  modalSubtitle: string = '';
  constructor(private orderService: OrderService, private toastr: ToastrService,) { }

  ngOnInit(): void {
    this.orderCount = this.orderIds.length;
    this.updateSubtitle();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // If modal becomes visible OR assignment mode changes, refresh list
    if ((changes['visible'] && changes['visible'].currentValue) ||
      (changes['isassign'] && !changes['isassign'].firstChange)) {
      this.refreshDriverList();
    }
  }

  refreshDriverList(): void {
    this.driverList = [];
    if (this.isassign) {
      this.getActiveDriversForAssign();
    } else {
      this.getActiveDriversForReassign();
    }
  }

  updateSubtitle() {
    if (this.orderCount === 1) {
      this.modalSubtitle = 'Select a driver to complete this delivery.';
    } else {
      this.modalSubtitle = `Select a driver to complete these ${this.orderCount} deliveries.`;
    }
  }

  onDriverChange(event: any) {
    this.selectedDriver = event.target.value;
  }

  closeModal() {
    this.close.emit();
  }

  assignOrder() {
    if (!this.selectedDriver) return;
    this.assign.emit({ driver: this.selectedDriver, orders: this.orderIds });
    this.closeModal();
  }
  closeassignOrder() {
    this.assign.emit({ driver: '', orders: [] });
    this.closeModal();
  }
  driverList: any[] = [];
  getActiveDriversForAssign(): void {
    this.orderService.getActiveDriversForAssign('active').subscribe({
      next: (res) => {
        if (res.result.special_group_info) {
          this.driverList.push({
            id: res.result.special_group_info.id,
            first_name: res.result.special_group_info.name,
            last_name: '',
            isSpecial: true
          });
        }
        res.result.results.forEach((data: any) => {
          this.driverList.push({
            id: data?.id,
            first_name: data?.first_name,
            last_name: data?.last_name,
            isOnline: data?.is_online,
            is_virtual_user: data?.is_virtual_user,
            headdriver: (data?.groups?.[0]?.id == 3 && !data?.is_virtual_user) ? '(HD)' : '',
            activity_status: data?.activity_status
          });
        });
      },
      error: (err) => {
        console.error('Error while fetching drivers', err);
      }
    });
  }
  getActiveDriversForReassign(): void {
    this.orderService.getActiveDriversForReassign('active', 'true').subscribe({
      next: (res) => {
        res.result.results.forEach((data: any) => {
          this.driverList.push({
            id: data?.id,
            first_name: data?.first_name,
            last_name: data?.last_name,
            isOnline: data?.is_online,
            is_virtual_user: data?.is_virtual_user,
            headdriver: (data?.groups?.[0]?.id == 3 && !data?.is_virtual_user) ? '(HD)' : '',
            activity_status: data?.activity_status
          });
        });
      },
      error: (err) => {
        console.error('Error while fetching drivers', err);
      }
    });
  }
}
